module.exports = __webpack_public_path__ + "static/media/Tempel_segesta.fb86f8cc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Tempel_segesta.JPG
// module id = 765
// module chunks = 0